export const tabs = (): void => {
  const tabContainers = document.querySelectorAll('.c-tabs');

  tabContainers.forEach((container) => {
    const tabs = container.querySelectorAll('.c-tabs__link');
    const panels = container.querySelectorAll('.c-tabs__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault();

        // Deactivate all tabs and hide all panels within this container
        tabs.forEach((t) => {
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });
        panels.forEach((panel) => {
          panel.setAttribute('hidden', 'true');
        });

        // Activate the clicked tab and show the corresponding panel
        this.setAttribute('aria-selected', 'true');
        this.setAttribute('tabindex', '0');
        const targetPanel = container.querySelector(this.getAttribute('href'));
        targetPanel.removeAttribute('hidden');
      });
    });
  });
};
